import { useRef } from 'react';

import { IImageMedia, IVideoMedia } from '~/lib/data-contract';
import { CarouselDescription, CarouselDescriptionContainer } from '~/shared/components/Carousel/components';
import { ImageMedia } from '~/shared/components/ImageMedia/ImageMedia';
import { VideoMedia } from '~/shared/components/VideoMedia/VideoMedia';
import { xsCondition } from '~/theme/lib/breakpoints';

import styles from './gallery.module.css';

import { RawHtml } from '../RawHtml/RawHtml';

export type GalleryItemType = (IImageMedia | IVideoMedia) & {
	description?: string | JSX.Element;
};

export type GalleryItemProps = {
	item: GalleryItemType;
	active?: boolean;
};

const imageSizes = [`${xsCondition} 100vw`, '50vw'].join(', ');

export const GalleryItem = ({ item }: GalleryItemProps) => {
	const swiperElementRef = useRef<HTMLDivElement>();

	return (
		<div
			className={`swiper-zoom-container ${styles.container}`}
			ref={(element) => {
				const swiper = element?.closest<HTMLDivElement>('.swiper');
				if (swiper) {
					swiperElementRef.current = swiper;
				}
			}}
		>
			<div className={`swiper-zoom-target ${styles.item}`}>
				{item.type === 'videoMedia' ? (
					<VideoMedia
						objectFit="contain"
						video={item}
					/>
				) : item.type === 'imageMedia' ? (
					<ImageMedia
						fill
						objectFit="contain"
						image={item}
						sizes={imageSizes}
						magnifier={'cover'}
						magnifyOnClick
					/>
				) : null}

				{item.description ? (
					<CarouselDescriptionContainer slot="container-end">
						<CarouselDescription>{typeof item.description === 'string' ? <RawHtml html={item.description} /> : item.description || null}</CarouselDescription>
					</CarouselDescriptionContainer>
				) : null}
			</div>
		</div>
	);
};
